<template>
  <b-card header="Assign manager status">
    <!-- <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
      <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
      <img class="navbar-brand-full" src="/static/img/preload.gif">
      </div>
    </div> -->
    <div>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Search</b-input-group-text></b-input-group-prepend>
          <input type="text" v-model="formData.userName" placeholder="Email or Phonenumber" class="form-control"/>
          <b-input-group-append><b-input-group-text><i class="nav-icon icon-user"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="form-group form-actions">
        <b-button @click="submitData" type="button" size="sm" variant="primary">Search</b-button>
      </div>
    </div>
  <b-table responsive="sm" :items="result" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
    <template slot="manager" slot-scope="data">
      <small class="text-muted ng-binding">
        <strong><i class="icon-user"></i>: {{data.item.managedBy.name}}</strong><br/>
        <strong><i class="icon-envelope"></i>:</strong> <a :href="mailto(data.item.managedBy.email)">{{data.item.managedBy.email}}</a><br/>
        <strong><i class="icon-phone"></i>:</strong> {{data.item.managedBy.phone}} <a :href="whatsapp(data.item.managedBy.phone)" :target="data.item.managedBy.phone"><i class="fa fa-whatsapp"></i></a>
      </small>
    </template>

    <template slot="activeDate" slot-scope="data">
      <small class="text-muted ng-binding">
        <i class="icon-calendar"></i> {{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
        -
         {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}
      </small>
      <div class="progress progress-xs" style="position:relative;margin-top:15px;margin-bottom:5px;">
        <div class="progress-bar bg-success" role="progressbar" :style="percentage(new Date(data.item.startDate).getTime(), new Date(data.item.endDate).getTime())" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </template>

    <template slot="owner" slot-scope="data">
      <small class="text-muted ng-binding">
        <strong><i class="icon-user"></i>: {{data.item.owner.name}}</strong><br/>
        <strong><i class="icon-envelope"></i>:</strong> <a :href="mailto(data.item.owner.email)">{{data.item.owner.email}}</a><br/>
        <strong><i class="icon-phone"></i>:</strong> {{data.item.owner.phone}} <a :href="whatsapp(data.item.owner.phone)" :target="data.item.owner.phone"><i class="fa fa-whatsapp"></i></a>
      </small>
    </template>
    <template slot="status" slot-scope="data">
      <small class="text-muted ng-binding">
       <i class="icon-calendar"></i>: {{(new Date(data.item.lastStatusDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric', hour: 'numeric', minute: 'numeric'})}}<br/>
       <strong>{{statuses[data.item.status]}}</strong>
      </small>
    </template>

    <template slot="action" slot-scope="data">
      <b-button type="button" variant="danger"  @click.stop="showModal(modalDeleteId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
        <i class="fa fa-trash"></i>
        Delete
      </b-button>

      <b-button type="button" variant="warning"  @click.stop="showModal(modalUnpaidId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
        <i class="fa fa-money"></i>
        Unpaid
      </b-button>

      <b-button type="button" variant="primary"  @click.stop="showModal(modalActivateId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
        <i class="fa fa-check-circle-o"></i>
        Active
      </b-button>
    </template>
  </b-table>

  <nav>
    <b-pagination :total-rows="getRowCount(result)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
  </nav>

  <div v-for="managerLoop in result" :key="managerLoop.managedBy.id">
    <b-modal :id="modalDeleteId(managerLoop.id)" @ok="handleOk(managerLoop.id, 'delete', modalId(managerLoop.id), $event.target)" centered>
      <div class="modal-window">
        <div class="alert alert-danger">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <p>Are you sure you want to delete the selected manager:<br/> <strong>{{ managerLoop.managedBy.name }}</strong>  for owner <strong>{{managerLoop.owner.name}}</strong>?</p>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <b-modal :id="modalUnpaidId(managerLoop.id)" @ok="handleOk(managerLoop.id, 'unpaid', modalId(managerLoop.id), $event.target)" centered>
      <div class="modal-window">
        <div class="alert alert-warning">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <p>Are you sure you want to update status the selected manager to UNPAID for:<br/> <strong>{{ managerLoop.managedBy.name }}</strong>  for owner <strong>{{managerLoop.owner.name}}</strong>?</p>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <b-modal :id="modalActivateId(managerLoop.id)" @ok="handleOk(managerLoop.id, 'activate', modalId(managerLoop.id), $event.target)" centered>
      <div class="modal-window">
        <div class="alert alert-success">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <p>Are you sure you want to ACTIVATE the selected manager:<br/> <strong>{{ managerLoop.managedBy.name }}</strong>  for owner <strong>{{managerLoop.owner.name}}</strong>?</p>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>

  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/search'
const API_UPDATE_STATUS = BASE + '/api/lockManagers/updateStatus'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function updateStatus (managerId, status) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    managerId: managerId,
    status: status
  }
  let res = await postdata(API_UPDATE_STATUS, parameters)
  return res.locations
}

export default {
  name: 'manager-status',
  data () {
    return {
      modalShowEmpty: false,
      result: [],
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        userName: ''
      },
      statuses: ['New', 'Active', 'Unpaid', 'Deleted'],
      fields: {
        manager: {
          label: 'Manager'
        },
        activeDate: {
          label: 'Period'
        },
        owner: {
          label: 'Owner'
        },
        status: {
          label: 'Status Manager'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      statis: ''
    }
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      if (localStorage.getItem('token')) {
        if (this.formData.userName.length > 5) {
          postdata(API, this.formData)
            .then(data => {
              // owner should add existing user as manager.
              // then owner request to newport to activate manager
              this.formData.searchTerm = ''
              this.result = data.result
            })
            .catch(error => {
              console.error(error)
            })
        } else {
          alert('Please put username or email')
        }
      }
    },
    getRowCount (items) {
      if (items) {
        return items.length
      } else return 0
    },
    mailto (email) {
      return 'mailto:' + email
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    },
    percentage (startDate, endDate) {
      let currtimestamp = new Date()
      let total = endDate - startDate
      let currentCount = currtimestamp.getTime() - startDate
      let percentage = 100 - ((currentCount * 100) / total)
      let val = 'width: ' + percentage + '%'
      return val
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    },
    modalDeleteId (i) {
      return 'modaldeletemanager' + i
    },
    modalUnpaidId (i) {
      return 'modalunpaidmanager' + i
    },
    modalActivateId (i) {
      return 'modalactivatemanager' + i
    },
    modalId (i) {
      return 'modal' + i
    },
    handleOk (id, action, modalId, button) {
      if (action == 'delete') {
        updateStatus(id, 3).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      } else if (action == 'unpaid') {
        updateStatus(id, 2).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      } else if (action == 'activate') {
        updateStatus(id, 1).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      }

      this.$root.$emit('bv::hide::modal', modalId, button)
    },
    refreshList () {
      // refresh list
      postdata(API, this.formData)
        .then(data => {
          this.result = data.result
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/intern/ManagerStatus.vue